__turbopack_context__.v({
  "accountId": "styles-module-scss-module__Lg8xbq__accountId",
  "img": "styles-module-scss-module__Lg8xbq__img",
  "root": "styles-module-scss-module__Lg8xbq__root",
  "subTitle": "styles-module-scss-module__Lg8xbq__subTitle",
  "text": "styles-module-scss-module__Lg8xbq__text",
});
